<div class="container-fluid">
  <div class="row">
    <div class="content">
      <div class="row">
        <button type="button" class="close" aria-label="Close" (click)="onCloseButtonClicked()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h1 class="heading">Get Started!</h1>
        <p class="subheading">Please enter your details, we will get in touch with you!</p>
      </div>

      <div class="row">
        <div>
          <form id="contactForm" [formGroup]="contactUsFormGroup"  #contactForm="ngForm" (ngSubmit)="onContactFormSubmit(contactForm, queryParams)"
                (keydown.enter)="$event.preventDefault()">

            <div class="row">
              <mat-form-field class="input-field">
                <p>Your name<sup class="text-color-red">*</sup></p>
                <input matInput placeholder="" [(ngModel)]="name" (keyup)="onNameInput($event)" name="name" type="text"
                       required maxlength="30" autocomplete="off" formControlName="name" >
                <mat-error *ngIf="contactUsFormGroup.controls.name.invalid">
                  {{ getErrorMessage(contactUsFormGroup.controls.name) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <p id="phone-field-label">Your mobile number<sup class="text-color-red">*</sup></p>
              <mat-form-field class="input-field">
                <p matPrefix class="text-color-grey phone-prefix">+91</p>
                <input matInput [(ngModel)]="phoneNumber" name="phoneNumber" autocomplete="off" maxlength="10"
                       formControlName="phoneNumber">
                <mat-error *ngIf="contactUsFormGroup.controls.phoneNumber.invalid">
                  {{ getErrorMessage(contactUsFormGroup.controls.phoneNumber) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field class="input-field">
                <p>Your email address</p>
                <input matInput placeholder="" maxlength="55" autocomplete="off" [(ngModel)]="email" name="email"
                       type="email" formControlName="email">
                <mat-error *ngIf="contactUsFormGroup.controls.email.invalid">
                  {{ getErrorMessage(contactUsFormGroup.controls.email) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field class="input-field">
                <p>Message<sup class="text-color-red">*</sup></p>
                <textarea matInput autocomplete="off" [(ngModel)]="message" name="message" title="Your message"
                          required type="text" formControlName="message"></textarea>
                <mat-error *ngIf="contactUsFormGroup.controls.message.invalid">
                  {{ getErrorMessage(contactUsFormGroup.controls.message) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="pull-right">
              <div *ngIf="!shouldShowLoader">
                <button mat-flat-button class="button-forward primary submit-contact-us" type="submit">SUBMIT</button>
              </div>

              <div *ngIf="shouldShowLoader">
                <mat-spinner></mat-spinner>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
